import React from 'react';
import { useTranslation } from 'react-i18next';

const WeddingIntro = () => {
  const { t } = useTranslation();

  return (
    <section className=" text-center py-10 px-5 rounded-md">
      <h2 className="text-4xl text-beast-brown-800 font-bold font-cursive mb-4">{t('wedding_intro.title')}</h2>
      <p className="text-lg text-beast-brown-700 font-medium mb-6">{t('wedding_intro.text')}</p>
      <div className="text-md text-beast-brown-700 font-medium ">
        <p>{t('wedding_intro.help_text')}</p>
      </div>
    </section>
  );
};

export default WeddingIntro;
